import { createFileRoute } from '@tanstack/react-router';

import { TravelReferenceDocumentBrowse } from '@/module/Travel/ReferenceDocument/TravelReferenceDocumentBrowse';
import { travelReferenceDocumentSearchSchema } from '@/module/Travel/ReferenceDocument/model/TravelReferenceDocumentSchema';
import { TravelReferenceDocumentKind } from '@/module/Travel/ReferenceDocument/model/TravelReferenceDocumentTypes';

export const Route = createFileRoute('/_auth/travel/_travel/documents/')({
  component: RouteComponent,
  validateSearch: travelReferenceDocumentSearchSchema,
});

function RouteComponent() {
  const { kind } = Route.useSearch();
  const navigate = Route.useNavigate();

  const onKindChange = (next: TravelReferenceDocumentKind) => navigate({ search: { kind: next }, replace: true });

  return (
    <TravelReferenceDocumentBrowse
      kind={kind}
      onKindChange={onKindChange}
    />
  );
}
